var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _vm.section.children
            ? _c(
                "v-expansion-panels",
                {
                  attrs: { multiple: "", accordion: "" },
                  model: {
                    value: _vm.localPanel,
                    callback: function ($$v) {
                      _vm.localPanel = $$v
                    },
                    expression: "localPanel",
                  },
                },
                [
                  _vm._l(_vm.section.children, function (child) {
                    return [
                      _c(
                        "v-expansion-panel",
                        { key: child.title, attrs: { lazy: "" } },
                        [
                          _c(
                            "v-expansion-panel-header",
                            { staticClass: "py-0" },
                            [
                              _c(
                                "div",
                                [
                                  _vm._v(" " + _vm._s(child.title) + " "),
                                  child.chart
                                    ? _c("Dialog", {
                                        attrs: {
                                          icon: "insert_chart",
                                          tooltip: "Show Chart",
                                          title: child.title,
                                          body: child.chart,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "v-expansion-panel-content",
                            { staticClass: "pa-0 px-4" },
                            [
                              child.children
                                ? _vm._l(child.children, function (grandchild) {
                                    return _c(
                                      "keep-alive",
                                      { key: grandchild.title },
                                      [
                                        _c(
                                          grandchild.component,
                                          _vm._b(
                                            { tag: "component" },
                                            "component",
                                            grandchild.props,
                                            false,
                                            true
                                          )
                                        ),
                                      ],
                                      1
                                    )
                                  })
                                : child.component
                                ? [
                                    _c(
                                      "keep-alive",
                                      [
                                        _c(
                                          child.component,
                                          _vm._b(
                                            {
                                              tag: "component",
                                              attrs: { title: child.title },
                                            },
                                            "component",
                                            child.props,
                                            false,
                                            true
                                          )
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                : [
                                    _c("v-card", [
                                      _vm._v(" Work In Progress "),
                                    ]),
                                  ],
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ]
                  }),
                ],
                2
              )
            : _c(
                "keep-alive",
                [
                  _c(
                    _vm.section.component,
                    _vm._b(
                      { tag: "component", attrs: { title: _vm.section.title } },
                      "component",
                      _vm.section.props,
                      false,
                      true
                    )
                  ),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }